import React from "react";
import dynamic from "next/dynamic";
// @ts-ignore
const Faq = dynamic(() => import("react-faq-component"), {
  ssr: false
});

const data = {
  rows: [
    {
      title: "So what is Coinage?",
      content: `Coinage is a weekly NFTV series answering crypto’s biggest questions, with host and finance reporter Zack Guzman. But really, it’s the first TV series built for the future of media. Because we’re not just producing a show — we’re building a community to help us run the show. And our combined experience and collective power is going to make that show worth watching. `
    },
    {
      title: "OK, but what’s an NFTV series?",
      content:
        "In short, it’s a TV series powered by its community. We’re piloting a new premium production model that will use membership passes to build a community that’s an onramp to producing and co-owning the Coinage ecosystem."
    },
    {
      title: "How will co-ownership of Coinage work?",
      content: `The short answer is: we’re working on it. There’s no precedent for what we’re doing, so we’re not leaving anything to chance. We’ve been hard at work confusing some of  the best lawyers in the business — all to ensure that co-ownership is not only fully compliant with U.S. law, but also a seamless experience for our membership pass holders. As we formalize our co-ownership model, we’ll be seeking input from our community before we set anything in stone.`
    },
    {
      title: "How do I watch Coinage?",
      content: (
        <p>
          If you have a Coinage membership pass, then you can connect your
          wallet to our platform to watch early and ad-free. If not, then you
          can catch us on Youtube and socials.
        </p>
      )
    },

    {
      title: "How do you mint a Network membership pass?",
      content: (
        <div>
          <p>
            Network membership passes are Coinage’s genesis collection. Network
            membership pass holders will be able to help produce and, pending
            some legal formalization, co-own the show. They’ll also be our brain
            trust as we get off the ground. There will only ever be 1,000
            Network membership passes, and all funds will go directly to show
            production and developing other Coinage projects.{" "}
          </p>{" "}
          <p>
            Network membership passes are invitation only, with Zack and a
            curated group of rivals from among our seed investors sending out
            the first few invitations. If you receive an invitation, you’ll be
            asked to participate in a novel trust experiment to mint. The
            outcome of your trust experiment will determine the number of
            invitations that you, in turn, receive. You may distribute those
            invites however you see fit.{" "}
          </p>
        </div>
      )
    },
    {
      title:
        "I didn’t get a Network invite. Can I still get a Network membership pass?",
      content:
        "Network membership passes are transferrable, so although we don’t recommend it, you may be able to find some for sale on secondary markets, such as OpenSea. But be careful to check the token contact address if you can, and only use Coinage links through our own site, emails, and socials to avoid copycats and scams. "
    },
    {
      title:
        "What’s the deal with Caucus membership passes? When and how can I mint one?",
      content: (
        <div>
          <p>
            Caucus membership passes will be Coinage’s signature collection.
            Like Network membership pass holders, Caucus membership pass holders
            will have the opportunity to help produce and co-own the show, but
            with a more accessible mint process. There will only ever be 5,000
            Caucus membership passes, and all funds raised will go directly to
            show production and developing Coinage projects.{" "}
          </p>{" "}
          <p>
            We’ll drop our Caucus membership passes around the end of Season 1,
            and announce the mint price in advance. You can register your wallet
            with <a href="https://www.premint.xyz/coinage/">PREMINT</a> for a
            spot on our access list and the chance to win a free Caucus
            membership pass (registering does not obligate you to mint). We’ll
            randomly select wallets to mint off the access list, and also
            reserve part of the collection for a public mint at the end of the
            process. Follow us on Twitter or Discord to stay in the loop, or
            just watch the show.
          </p>
        </div>
      )
    },
    {
      title:
        "What’s the deal with Subscriber membership passes? Should I mint one?",
      content: (
        <div>
          <p>
            Subscriber membership pass holders will be able to watch the show
            ad-free on our site and have access to private Discord channels.
            They’re free for Season 1, though you’ll have to pay a small
            transaction fee, also known as “gas.” There will be an unlimited
            number of Subscriber membership passes.
          </p>
          <p>
            Subscriber membership passes are a great way to get started in the
            Coinage community. You’ll get early access to Coinage content,
            experiences, and more. And you’ll be in a tighter, private
            community.
          </p>
        </div>
      )
    },

    {
      title: "What does Coinage mean by “editorially independent?”",
      content:
        "Our community will certainly inform and elevate our thinking — that's half the point here — and often be key sources for our coverage. But owning a Coinage membership pass does not grant the power to dictate or censor what Coinage covers. Simply put, we're not worth the servers we run on if we can't earn the trust of our viewers. Maintaining editorial independence is the first essential step down that path."
    },
    {
      title: "How will governance of the show work?",
      content: (
        <div>
          <p>
            Coinage will be a progressively decentralized production — Season 1
            has been shepherded by a mostly centralized team to get the show up
            and running. As we move forward, we’ll be tinkering with new ideas
            to leverage the power and know-how of our decentralized community,
            and to flip the script on the traditional production playbook.{" "}
          </p>{" "}
          <p>
            We won’t sugarcoat it: this is going to be an experimental process.
            We’re keeping an open mind, and hope you will too. Can a
            decentralized community produce premium content? Can working
            together make all our lives easier, not harder? And can we build an
            intuitive model that lets us become more than the sum of our parts?
            Our Season 2 strategy will emerge as we seek answers to these
            questions in Season 1.
          </p>
        </div>
      )
    },
    {
      title: "Who’s behind Coinage?",
      content:
        "Coinage is the first project from Trustless Media, a new kind of production hub where ideas people care about actually come to life. "
    }
  ]
};

const styles = {
  bgColor: "#FF4518",
  titleTextColor: "white",
  rowTitleColor: "white",
  rowContentColor: "white",
  arrowColor: "white"
};

const config = {};

type FAQ = {};

export const FAQ: React.FC<FAQ> = ({}) => {
  // @ts-ignore
  return <Faq data={data} styles={styles} config={config} />;
};
